import { apiSlice } from "../../api/ApiService";

const getMilestoneTaskApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMilestoneTask: builder.query({
      query: ({ accessToken, milestoneTaskId }: { accessToken: string | null, milestoneTaskId: string }) => ({
        url: `/api/v1/Administration/${milestoneTaskId}/milestone`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),     
      providesTags: (result, error, {milestoneTaskId}) => [
        { type: "MilestoneTask", id: milestoneTaskId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetMilestoneTaskQuery } = getMilestoneTaskApi;
export default getMilestoneTaskApi;
